import { ASSOCIATE_MANAGER_ROLE, MANAGER_ROLE } from '../../constants/common';

export const MEMBERSHIP_KINDS = {
    member: { key: 'member', label: 'member', action: 'Add member', allowsSecondary: false },
    manager: { key: 'manager', role: MANAGER_ROLE, label: 'manager', action: 'Add manager', allowsSecondary: true },
    associateManager: {
        key: 'associateManager',
        role: ASSOCIATE_MANAGER_ROLE,
        label: 'associate manager',
        action: 'Add associate manager',
        allowsSecondary: true,
    },
};

const roleOf = (person) => (person?.role || '').toLowerCase();

export const hasRole = (person, role) => roleOf(person) === role;

export const isLeader = (person) => hasRole(person, MANAGER_ROLE) || hasRole(person, ASSOCIATE_MANAGER_ROLE);

const primaryWithRole = (members, role) => members.filter((m) => !m.isSecondary && hasRole(m, role));
const secondaryWithRole = (members, role) => members.filter((m) => m.isSecondary && hasRole(m, role));

export const groupTeamMembers = (members = []) => {
    const primary = members.filter((m) => !m.isSecondary);
    return {
        managers: [...primaryWithRole(members, MANAGER_ROLE), ...secondaryWithRole(members, MANAGER_ROLE)],
        associateManagers: [
            ...primaryWithRole(members, ASSOCIATE_MANAGER_ROLE),
            ...secondaryWithRole(members, ASSOCIATE_MANAGER_ROLE),
        ],
        teamMembers: primary.filter((m) => !isLeader(m)),
    };
};

export const getPrimaryLeader = (members = [], role) => primaryWithRole(members, role)[0];

export const DERIVED_SUPERVISOR_TEXT = "Assigned automatically from the team's primary Associate Manager or Manager.";

export const isSupervisorDerived = (role, primaryLeaderIds = []) =>
    Boolean(role) && !isLeader({ role }) && primaryLeaderIds.length > 0;

export const isEligibleCandidate = (person, kind, members = []) => {
    if (members.some((m) => m.userId === person.userId)) return false;
    return kind.role ? hasRole(person, kind.role) : !isLeader(person);
};
